"use client";

import React, {createContext, useContext, useMemo} from "react";

interface ClientCloseContextProps {
    closeAction: () => void;
}

const ClientCloseContext = createContext<ClientCloseContextProps | null>(null);

export const CloseContextProvider = ({ children, closeAction } : {
    children: React.ReactNode;
    closeAction: () => void;
}) => {

    const value = useMemo(() => ({ closeAction }), [closeAction]);

    return (
        <ClientCloseContext.Provider value={value}>
            {children}
        </ClientCloseContext.Provider>
    );

};

export const useClientClose = () => {
    const context = useContext(ClientCloseContext);
    if (context === null) {
        throw new Error("useClientClose must be used within a CloseContextProvider.");
    }
    return context;
};
